import type { CreferenceResolvedEntity } from "./useCreferenceResolvedEntity";
import type { UseCreferenceInteractionInput } from "./creferenceInteractionTypes";

interface BuildCreferenceInteractionInput {
  disabled: boolean;
  onClick?: () => void;
  resolvedEntity: CreferenceResolvedEntity;
}

export function buildCreferenceInteractionInput({
  disabled,
  onClick,
  resolvedEntity,
}: BuildCreferenceInteractionInput): UseCreferenceInteractionInput {
  return {
    collab: resolvedEntity.collab,
    disabled,
    effectiveEntityType: resolvedEntity.effectiveEntityType,
    file: resolvedEntity.file,
    isCurrentUserReference: resolvedEntity.isCurrentUserReference,
    isLoading: resolvedEntity.isLoading,
    isUnresolved: resolvedEntity.isUnresolved,
    member: resolvedEntity.member,
    normalizedEntityId: resolvedEntity.normalizedEntityId,
    onClick,
    product: resolvedEntity.product,
    version: resolvedEntity.version,
  };
}
